var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({staticClass:"rmr-input",class:{ 'rmr-input--md': _vm.size === 'md' },attrs:{"value":_vm.value,"dense":"","outlined":"","hide-details":_vm.hideDetails}},'v-text-field',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }